import React from 'react';
import classNames from 'classnames';

interface CreditCardFieldProps {
  id: string;
  label: string;
  icon?: string;
  isInvalid?: boolean;
  isDarkTheme?: boolean;
}

export const CreditCardField: React.FC<CreditCardFieldProps> = props => {
  const { id, label, icon = '' } = props;
  const classes = classNames('form-row no-error-msg', {
    'form-row-dark': props.isDarkTheme,
    error: props.isInvalid,
    'form-credit-card-icon': icon,
  });
  const iconClasses = classNames('icon', ['icon-' + icon]);

  return (
    <div className={classes}>
      <label htmlFor={id}>{t(label)}</label>
      <div className="input" id={id} />
      {icon && <div className={iconClasses} />}
    </div>
  );
};
